import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=bba8152a&scoped=true"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba8152a",
  null
  
)

export default component.exports